"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
exports.TEST_KEYS = exports.PROD_KEYS = void 0;

var _analytics = require("../../analytics");

var PROD_KEYS = {
  REGULAR: "2dd365854848a5902c8900ab532de155",
  POSING: "e8f187410c83f7111bb0b53a80264823"
};
exports.PROD_KEYS = PROD_KEYS;
var TEST_KEYS = {
  REGULAR: "470c2c0f17f36f26c01ed83a87e87599",
  POSING: "f96973bba5e7752bc253fde9f30cc3a2"
};
exports.TEST_KEYS = TEST_KEYS;

function getEnvKeys(isProd) {
  return isProd ? PROD_KEYS : TEST_KEYS;
}

function getPosingKey(isPosing) {
  return isPosing ? "POSING" : "REGULAR";
}

function init() {
  var isProd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isPosing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _analytics.initialize)(getEnvKeys(isProd)[getPosingKey(isPosing)], options);
}